import React, { ReactNode } from 'react';
import Tooltip, { TooltipData } from '../tooltip/tooltip';

export interface LabelProps {
  id?: string;
  infoData?: TooltipData;
  className?: string;
  label: ReactNode;
  required?: boolean;
  labelHidden?: boolean;
}

const Label = ({ id, infoData, className, label, required, labelHidden }: LabelProps) => {
  return (
    <div className='flex items-end'>
      <label
        htmlFor={id}
        className={`mb-1 text-sm capitalize text-text ${className} ${labelHidden ? 'invisible' : ''}`}>
        {label} {required && <span className='text-error'>*</span>}
      </label>
      {infoData && (
        <Tooltip
          infoData={infoData}
          className='ml-4'
        />
      )}
    </div>
  );
};

export default Label;
